<template>
  <div id="lottery-box" class="lottery-box" v-show="gameShowFlag">
    <div class="lottery">
      <div class="lottery-item">
        <div class="lottery-start">
          <div class="box gray" v-if="isStart===0">
            <p>活动未开始</p>
          </div>
          <div class="box" @click="startLottery" v-if="isStart===1">
            <p>
              <b>抽奖</b>
            </p>
            <!-- <p>消耗{{score}}积分</p> -->
          </div>
          <div class="box gray" v-if="isStart===2">
            <p>活动已过期</p>
          </div>
        </div>
        <ul>
          <li v-for="(item,i) in list" :class="i==index?'on':''">
            <div class="box">
              <p>
                <img src="../../assets/j2.png" alt />
              </p>
              <p>{{item.dictLabel}}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="mask" v-if="showToast"></div>
    <div class="lottery-alert" v-if="showToast">
      <h1>恭喜您</h1>
      <p>
        <img src="../../assets/j2.png" alt />
      </p>
      <h2>获得{{list[index].dictLabel}}</h2>
      <div class="btnsave" @click="nextPage">确定</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "pmdGame",
  data() {
    return {
      gameShowFlag: false,
      isStart: 1,
      score: 10, //消耗积分
      list: [
        // {img:this.locationImg + '/j2.png',title:'谢谢参与'},
        // {img:this.locationImg + '/j2.png',title:'美女一个'},
        // {img:this.locationImg + '/j1.png',title:'宝马一辆'},
        // {img:this.locationImg + '/j2.png',title:'单车一辆'},
        // {img:this.locationImg + '/j1.png',title:'鸡蛋一蓝'},
        // {img:this.locationImg + '/j2.png',title:'500红包'},
        // {img:this.locationImg + '/j1.png',title:'靓号一个'},
        // {img:this.locationImg + '/j2.png',title:'鲜花一蓝'}
      ], //奖品1-9
      index: -1, // 当前转动到哪个位置，起点位置
      count: 8, // 总共有多少个位置
      timer: 0, // 每次转动定时器
      speed: 200, // 初始转动速度
      times: 0, // 转动次数
      cycle: 80, // 转动基本次数：即至少需要转动多少次再进入抽奖环节
      prize: -1, // 中奖位置
      click: true,
      showToast: false, //显示中奖弹窗
      resultIndex: 0,
      resultUserId: "",
      resultSpeIndex: null
    };
  },
  created() {
    this.getList();
    this.getResult();
  },
  mounted() {
    this.$nextTick(() => {
      const body = document.querySelector("body");
      if (body.append) {
        body.append(this.$el);
      } else {
        body.appendChild(this.$el);
      }
    });
  },
  methods: {
    gameShow() {
      this.gameShowFlag = true;
    },
    gameClose() {
      this.gameShowFlag = false;
    },
    async getList() {
      const res = await this.$http.get("/mobile/dict/data/public/mobileList", {
        dictType: "red_packet_list"
      });
      this.list = res.rows;
    },
    async getResult() {
      const res = await this.$http.get("/mobile/dict/data/public/mobileList", {
        dictType: "red_packet"
      });
      // console.log(res)
      this.resultIndex = Number(res.rows[0].dictLabel) - 1;
      let obj = JSON.parse(res.rows[0].remark);
      this.resultUserId = obj.userId;
      this.resultSpeIndex = Number(obj.pos) - 1;
    },
    async changeStatus() {
      const res = await this.$http.post("/mobile/producerAwardLog/save", {});
      if (res.code == 0) {
        this.$emit("change", "false");
        this.startRoll();
      }
    },
    nextPage() {
      this.showToast = false;
      this.gameShowFlag = false;
      this.$router.push({ name: "increaseWeChat" });
    },
    startLottery() {
      if (!this.click) {
        return;
      }
      // this.startRoll();
      this.click = false;
      this.changeStatus();
    },
    // 开始转动
    startRoll() {
      this.times += 1; // 转动次数
      this.oneRoll(); // 转动过程调用的每一次转动方法，这里是第一次调用初始化
      // 如果当前转动次数达到要求 && 目前转到的位置是中奖位置
      if (this.times > this.cycle + 10 && this.prize === this.index) {
        clearTimeout(this.timer); // 清除转动定时器，停止转动
        this.prize = -1;
        this.times = 0;
        this.speed = 200;
        var that = this;
        setTimeout(res => {
          that.showToast = true;
          this.click = true;
        }, 500);
      } else {
        if (this.times < this.cycle) {
          this.speed -= 10; // 加快转动速度
        } else if (this.times === this.cycle) {
          // const index = parseInt(Math.random() * 10, 0) || 0; // 随机获得一个中奖位置
          this.prize =
            this.resultUserId == localStorage.userId
              ? this.resultSpeIndex
              : this.resultIndex; //中奖位置,可由后台返回
          if (this.prize > 7) {
            this.prize = 7;
          }
        } else if (
          this.times > this.cycle + 10 &&
          ((this.prize === 0 && this.index === 7) ||
            this.prize === this.index + 1)
        ) {
          this.speed += 110;
        } else {
          this.speed += 20;
        }
        if (this.speed < 40) {
          this.speed = 40;
        }
        this.timer = setTimeout(this.startRoll, this.speed);
      }
    },
    // 每一次转动
    oneRoll() {
      let index = this.index; // 当前转动到哪个位置
      const count = this.count; // 总共有多少个位置
      index += 1;
      if (index > count - 1) {
        index = 0;
      }
      this.index = index;
    }
  }
};
</script>
<style scoped lang="stylus">
.lottery-box {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100vw;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;

  .title {
    text-align: center;
    padding: 50px 0;
    font-size: 18px;
    color: #fff;
  }

  .lottery {
    animation: changeBg 0.5s ease infinite;
    overflow: hidden;
    padding: 20px;
    width: 80vw;
    height: 80vw;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-size: 100% 100%;

    @keyframes changeBg {
      0% {
        background-image: url('./img/k1.png');
      }

      100% {
        background-image: url('./img/k2.png');
      }
    }

    .lottery-item {
      height: 22vw;
      position: relative;
      margin-top: 10px;
      margin-left: 10px;
    }

    .lottery-item ul li {
      width: 22vw;
      position: absolute;
      padding-right: 10px;
      background-color: transparent;
    }

    .lottery-item ul li:nth-child(2) {
      left: 33.33333333%;
    }

    .lottery-item ul li:nth-child(3) {
      left: 66.66666666%;
    }

    .lottery-item ul li:nth-child(4) {
      left: 66.66666666%;
      top: 25vw;
    }

    .lottery-item ul li:nth-child(5) {
      left: 66.66666666%;
      top: 51vw;
    }

    .lottery-item ul li:nth-child(6) {
      left: 33.33333333%;
      top: 51vw;
    }

    .lottery-item ul li:nth-child(7) {
      left: 0;
      top: 51vw;
    }

    .lottery-item ul li:nth-child(8) {
      left: 0;
      top: 25vw;
    }

    .lottery-item ul li .box {
      height: 22vw;
      position: relative;
      text-align: center;
      overflow: hidden;
      background: url('./img/bg2.png') no-repeat center;
      background-size: 100% 100%;
      background-color: transparent;
    }

    .lottery-item ul li .box img {
      display: block;
      height: 50px;
      margin: 0 auto;
      margin-top: 5px;
      margin-bottom: 5px;
    }

    .lottery-item ul li .box p {
      color: #708ABF;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 14px;
    }

    .lottery-item ul li.on .box {
      background: url('./img/bg1.png') no-repeat center;
      background-size: 100% 100%;
    }

    .lottery-item ul li.on .box p {
      color: #fff;
    }

    .lottery-item .lottery-start {
      position: absolute;
      left: 33.33333333%;
      width: 22vw;
      top: 25vw;
      padding-right: 10px;
    }

    .lottery-item .lottery-start .box {
      height: 22vw;
      font-size: 14px;
      color: #fff;
      cursor: pointer;
      text-align: center;
      overflow: hidden;
      background: url('./img/bg1.png') no-repeat center;
      background-size: 100% 100%;
    }

    .lottery-item .lottery-start .box p b {
      font-size: 32px;
      line-height: 22vw;
      display: block;
    }

    .lottery-item .lottery-start .box:active {
      opacity: 0.7;
    }

    .lottery-item .lottery-start .box.gray {
      // background: url(./img/bg3.png) no-repeat center;
      // background-size: 100% 100%;
    }

    .lottery-item .lottery-start .box.gray p {
      color: #708ABF;
      font-weight: bold;
    }
  }
}

.mask {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  overflow: hidden;
  z-index: 222;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.lottery-alert {
  width: 80vw;
  text-align: center;
  z-index: 10000;
  border-radius: 10px;
  background: #fff;
  padding: 20px;
  position: fixed;
  left: 0;
  right: 0;
  margin: auto;
  top: 50%;
  transform: translateY(-50%);
}

.lottery-alert h1 {
  font-size: 18px;
  font-weight: bold;
  color: #D92B2F;
}

.lottery-alert img {
  display: block;
  height: 120px;
  margin: 0 auto;
}

.lottery-alert h2 {
  font-weight: normal;
  color: #D92B2F;
  font-size: 15px;
  padding-top: 15px;
}

.lottery-alert p {
  color: #666;
  font-size: 16px;
  padding-top: 5px;
}

.lottery-alert .btnsave {
  border-radius: 3px;
  box-shadow: none;
  height: 40px;
  cursor: pointer;
  line-height: 40px;
  color: #fff;
  margin-top: 12px;
  background: linear-gradient(180deg, rgba(213, 60, 63, 1) 0%, rgba(201, 20, 24, 1) 100%);
  font-size: 16px;
}
</style>